module.exports = __webpack_public_path__ + "img/Ellipse 24.f58e6198.png";